<template>
<div class="relative">
	<div class="fixed white" style="width: 100%;" id="tool-bar">
    <v-row style="width: 100%" class="ma-0" align="center">
		<v-col cols="12" class="d-flex flex-column pe-0">
			<slot name="breadcrumbs" :item="true" class="journal-breadcrumbs"></slot>
		</v-col>

		<v-col cols="auto" lg="auto" sm="12" md="auto" class="flex-grow-1 d-flex">
		<v-layout wrap class="d-flex flex-row my-border rounded-lg">
			<v-col cols="auto" md="auto" style="width: auto !important;" class="d-flex align-center justify-start pe-0">
			<bee-bond-up-down v-model="bond_no" @keydown-enter-prevent="fetchBond()" @programmatically-changed="fetchBond()" :items="this.simplified_bonds.map(c=>c.bond_no)" class="medium-placeholder" :label="$t('CashJournalPage.bond-number')"></bee-bond-up-down>
				</v-col>
				<v-col cols="auto" sm="auto" xs="12" md="auto" lg="auto" class="d-flex align-center">
					<bee-btn
					    context="bond"
					    :action-name="actions.EDIT"
					    :content="on_lgAndUp ?
							bond.is_posted ? $t('CashJournalPage.edit') : $t('CashJournalPage.save')
							: ''
						"
					    :icon="bond.is_posted ? 'fa-envelope-open' : 'fa-envelope'"
					    :outer-class="on_lgAndUp ? 'text-wrap' : ''" 
					    :disabled="file_is_locked"
					    :loading="updateBondLoading"
					    :color="bond.is_posted ? 'deletingColor' : 'blueGray'"
					    @click="bond.is_posted ? unPosting() : posting()"
					></bee-btn>

					<bee-btn
						context="bond"
						:action-name="actions.CREATE"
						icon="fa-plus"
						:disabled="file_is_locked"
						@click="create_bonds_manually ? addBondDialog = true : addBond()"
						:content="$t('CashJournalPage.new')"
						color="addingColor"
						outer-class="ms-3"
						:loading="loading"
					></bee-btn>
				</v-col>

				
				<v-spacer v-if="on_mdAndUp"></v-spacer>
				<v-col lg="auto" md="auto" cols="auto" sm="auto" xs="12" class="d-flex align-center">
					<bee-btn  
						:content="$t('CashJournalPage.cash-statement') + ` (${main_box.name})`"
						color="editingColor"
						icon="far fa-share-square fa-rotate-180"
						@click="statementAccount()"
						outer-class="me-3"
						context="statement"
						:action-name="actions.GET"
					></bee-btn>
					<bee-btn
						@click="createAccount()"
						:disabled="file_is_locked"
						color="addingColor"
						:content="$t('CashJournalPage.add')"
						icon="fa-user-plus"
						context="account"
						:action-name="actions.CREATE"
					></bee-btn>
				</v-col>
				<v-spacer v-if="on_mdAndUp"></v-spacer>

				<v-col cols="auto" class="d-flex align-center py-0 pe-lg-0 justify-md-end my-0">
					<bee-outlined-header-info
					    :head="on_lgAndUp
							? $t('CashJournalPage.posted-journals-balance')
							: $t('CashJournalPage.posted-journals-balance') + ':' "
					    border-color="transparent"
					    class="px-lg-0"
					    :column="on_lgAndUp"
					>
						<template  v-slot:content="{}">
							<bee-advanced-money-label :currencies="configs.currencies" v-model="box_balance" :withColor="true" empty-state="_"></bee-advanced-money-label>
						</template>
					</bee-outlined-header-info>
				</v-col>

				<v-col cols="auto" class="d-flex justify-lg-end py-1">
					<router-link style="text-decoration: none;" :to="{name: 'journals'}">
						<bee-progress-circular
							:tooltip="bond_posting_ratio_tooltip"
							:size="60"
							:width="6"
							:value="bond_posting_ratio"
							:title="bond_posting_ratio_caption"
							class="text-caption"
						>
						{{ bond_posting_ratio_caption }}
						</bee-progress-circular>
					</router-link>
				</v-col>
				<v-col lg="1" md="12" sm="12" xs="12" cols="12" 
                    :class="[
						bond.is_posted ? 'postedColor': 'unpostedColor',
						on_lgAndUp ? 'border-round-end' : 'border-round-bottom'
					]"
                    :style="on_lgAndUp ? 'height: 100%; ' : ''" 
                    style="border-color: transparent !important;  align-items: center !important;" 
                    class="justify-content-center justify-center flex-grow-1 d-flex white--text my-border text--title text-center align-center font-weight-bold text-wrap">
					<span class="text-center align-center" style="line-height: 1.2;">
						{{bond.is_posted ? '' : $t('CashJournalPage.not')}}
					<br v-if="!bond.is_posted">{{$t('CashJournalPage.posted')}}</span>
				</v-col>
		</v-layout>
		</v-col>
    </v-row>
	</div>
	<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
    <v-card flat>
		<v-card-text class="py-0 px-3">
			<bee-smart-table max-height="65vh" mode="funds" context="entry" 
			 	:action-name="actions.CREATE" ref="table" :with-color="false" 
				:zebra="true" 
				empty-state="dashes" 
				:hide-footer="true"
				@cell-change="entries[$event.index][$event.header.value] = $event.value"
				:addable="addable && !file_is_locked" 
				:editable="!bond.is_posted && !file_is_locked" 
				@reset-data="fetchEntry($event)" 
				:headers="headers"
				:items="entries"
				:show-menu-actions="true"
				@row-edited="updateEntry($event)"
				@row-added="addEntry($event)" 
				@delete-item="deleteEntry($event)"
				@account-statement="goToAccountStatement($event)"
				highlighted-color="blueGray lighten-3"
				:highlighted-expression="(item)=>{ return item.id == $route.query.entryId || item.linked_entry_id == $route.query.entryId }" 
				:right-click-menu-items="actionsList"
				:configs="custom_configs"
				:messagesSelectRowValidation="messagesSelectRowValidation"
				@nblur="handlBlurBoundTable">
			</bee-smart-table>
		</v-card-text>
    </v-card>
	<bee-dialog
	    @handler="confirmDeleteEntry(); $emit('close')"
	    @close="dialogDeleteCashEntry = false"
	    v-model="dialogDeleteCashEntry"
	    :title="$t('CashJournalPage.delete-cash-entry')"
	    :message="$t('CashJournalPage.are-you-sure-you-want-delete-the-entry')"
	></bee-dialog>
    <v-dialog v-model="addBondDialog" max-width="500" transition="dialog-top-transition">
		<v-card>
			<v-card-title class="headline">
				{{$t('CashJournalPage.add-bond')}}
			</v-card-title>
			<v-card-text>
				<bee-date-picker
				    context="bond"
				    :action-name="actions.CREATE"
				    :label="$t('CashJournalPage.bond-date')"
				    v-model="bond_date"
				    :rules="[this.rules.date]"
				></bee-date-picker>
			</v-card-text>
			<v-card-actions class="ms-3">
				<v-btn color="greenDarken1" text @click="addBond()" :loading="loading">
					{{$t('CashJournalPage.create')}}
				</v-btn>
				<v-btn color="redDarken1" text @click="addBondDialog = false">
					{{$t('CashJournalPage.cancel')}}
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
    </v-dialog>
	<account-form v-model="showAccountForm"></account-form>
    <bee-confirm-dialog
		@close="alertNoBoxAccountDialog = false; $router.push({name: 'default-accounts'})"
		v-model="alertNoBoxAccountDialog"
		:title="$t('CashJournalPage.warning')"
		:message="$t('CashJournalPage.No-fund-has-been-set-for-the-financial-file-yet')"
    ></bee-confirm-dialog>
	</div>
	<v-bottom-navigation
		id="footer"
		app
		horizontal
		class="px-3 justify-lg-space-between"
		background-color="#E1E2E4"
	>
		<div class="d-flex flex-grow-1 align-center">
			<bee-label
				v-if="on_lgAndUp"
				:content="$t('CashJournalPage.sum')"
				:bold="true"
				class="primary--text ps-4"
			></bee-label>
			
			<!-- total-exports -->
			<bee-advanced-money-label
				v-if="on_lgAndUp"
				class="mx-8"
				v-model="sum_debits"
				:bold="true"
				:with-color="true"
				:currencies="configs.currencies"
			/>
			<div v-else cols="auto" class="ma-0 pa-0 d-flex justify-start flex-column">
				<bee-outlined-header-info
					border-color="transparent"
					:head="$t('CashJournalPage.total-exports')"
					:column="true"
					class="py-lg-0"
				>
					<template  v-slot:content="{}">
						<bee-advanced-money-label empty-state="_" v-model="sum_debits" :bold="true" :with-color="true" :currencies="configs.currencies"></bee-advanced-money-label>
					</template>
				</bee-outlined-header-info>
			</div>

			<!-- total-imports -->
			<bee-advanced-money-label
				v-if="on_lgAndUp"
				v-model="sum_credits"
				:bold="true"
				:with-color="true"
				:currencies="configs.currencies"
				class="mx-6"
			/>
			<div v-else class="d-flex justify-end">
				<bee-outlined-header-info
					border-color="transparent"
					:head="$t('CashJournalPage.total-imports')"
					:column="true"
					class="py-lg-0"
				>
					<template  v-slot:content="{}">
						<bee-advanced-money-label
							v-model="sum_credits"
							:bold="true"
							empty-state="_"
							:with-color="true"
							:currencies="configs.currencies"
						/>
					</template>
				</bee-outlined-header-info>
			</div>

			<!-- difference -->
			<bee-outlined-header-info
				v-if="on_lgAndUp"
				border-color="transparent"
				style="width:18%;"
				:head="$t('CashJournalPage.difference')"
				:column="!on_lgAndUp"
			>
				<template v-slot:content="{}">
					<bee-advanced-money-label
						v-model="sum_difference"
						empty-state="_"
						:bold="true"
						:with-color="true"
						:currencies="configs.currencies"
					/>
				</template>
			</bee-outlined-header-info>
			<div v-else class="d-flex justify-lg-end">
				<bee-outlined-header-info
					:head="$t('CashJournalPage.difference')"
					:column="true"
					border-color="transparent"
				>
					<template  v-slot:content="{}">
						<bee-advanced-money-label empty-state="_" v-model="sum_difference" :bold="true" :with-color="true" :currencies="configs.currencies"></bee-advanced-money-label>
					</template>
				</bee-outlined-header-info>
			</div>

			<!-- revolving-balance -->
			<div v-if="on_mdAndUp" class="d-flex align-center justify-md-end">
				<bee-outlined-header-info
					:head="$t('CashJournalPage.revolving-balance')"
					:column="false"
					border-color="transparent"
				>
					<template v-slot:content="{}">
						<bee-advanced-money-label
							empty-state="_"
							v-model="revolvingBalance"
							:bold="true"
							:with-color="true"
							:currencies="configs.currencies"
						></bee-advanced-money-label>
					</template>
				</bee-outlined-header-info>
			</div>
			<div v-else class="d-flex align-center justify-md-end">
				<bee-outlined-header-info
					:head="$t('CashJournalPage.revolving-balance')"
					:column="true"
					border-color="transparent"
				>
					<template v-slot:content="{}">
						<bee-advanced-money-label
							empty-state="_"
							v-model="revolvingBalance"
							:bold="true"
							:with-color="true"
							:currencies="configs.currencies"
						></bee-advanced-money-label>
					</template>
				</bee-outlined-header-info>
			</div>

			<!-- outcome-coins -->
			<div v-if="on_lgAndUp" class="mx-10">
				<div
					v-for="currency in currency_debits? currency_debits.split(',') : []"
					v-bind:key="currency"
				>
					<bee-label
						:showOnlyNumbersPatch="true"
						class="text-center"
						color="red"
						:content="currency"
						:bold="true"
					/>
				</div>
			</div>
			<div v-else class="d-flex flex-column justify-center">
				<bee-outlined-header-info
					:head="$t('CashJournalPage.outcome-coins')"
					:column="true"
					class="py-lg-0"
					border-color="transparent"
				>
					<template  v-slot:content="{}">
						<bee-label :showOnlyNumbersPatch="true" empty-state="_" :content="currency_debits" :bold="true" color="green"></bee-label>
					</template>
				</bee-outlined-header-info>
			</div>

			<!-- incoming-coins -->
			<div v-if="on_lgAndUp" class="text-center mx-8">
				<div
					v-for="currency in currency_credits? currency_credits.split(',') : []"
					v-bind:key="currency"
				>
					<bee-label
						:showOnlyNumbersPatch="true"
						class="text-center"
						color="green"
						:content="currency"
						:bold="true"
					/>
				</div>
			</div>
			<div v-else class="d-flex flex-column justify-center">
				<bee-outlined-header-info
					:head="$t('CashJournalPage.incoming-coins')"
					:column="true"
					class="py-lg-0"
					border-color="transparent"
				>
					<template  v-slot:content="{}">
						<bee-label
							:showOnlyNumbersPatch="true"
							empty-state="_"
							:content="currency_credits"
							:bold="true"
							color="red"
						/>
					</template>
				</bee-outlined-header-info>
			</div>
			
			<v-spacer/>

			<!-- currency-equivalent -->
			<div
				v-if="show_symbol_currencies"
				cols="auto"
				class="ma-0 pe-1 d-flex justify-lg-end justify-md-end justify-center"
			>
				<v-menu
					v-model="show"
					top
					offset-y
					right
					transition="slide-y-transition"
					max-width="400"
					:close-on-click="false"
					:close-on-content-click="false"
				>
					<template v-slot:activator="{ on }">
						<v-btn
							class="pe-0"
							depressed
							color="transparent"
							v-on="on"
							@click="show = !show"
						>
							<v-icon class="mx-1">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
							{{$t('CashJournalPage.currency-equivalent')}}
						</v-btn>
					</template>
					<v-card>
						<v-card-text  class="py-1">
							<v-row align="center" class="my-0">
								<v-card-subtitle class="py-0">
									{{$t('CashJournalPage.select-currency-to-show-the-currency-equivalent')}}
								</v-card-subtitle>
								<v-spacer></v-spacer>
								<v-btn icon @click="show = !show"><v-icon>mdi-close</v-icon></v-btn>
							</v-row>
							<v-row class="my-0">
								<v-col cols="12" lg="5" class="pe-lg-0">
									<bee-currencies-autocomplete   
										item-text="symbol"
										:items="configs.currencies.filter(c=>c.id != configs.financial_file.default_currency_id) || []"
										v-model="sum_difference_equivalent.currency_id"
										@change="changeSumDifferenceEquivalent($event)"
									></bee-currencies-autocomplete>
								</v-col>
								<v-col class="px-lg-0">
									<bee-outlined-header-info border-color="transparent" :column="false">
										<template  v-slot:head="{}">
											<bee-advanced-money-label v-model="sum_difference_equivalent" :bold="true" :with-color="true" :currencies="configs.currencies"></bee-advanced-money-label>
										</template>
									</bee-outlined-header-info>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-menu>
			</div>
		</div>
    </v-bottom-navigation>
</div>
</template>
<script>
import rules from "../../../validation";
import { mapState } from "vuex";
import  store  from "../../../store/index.js";
import _ from 'lodash'
import EventBus from '../../../event-bus'
import { refactorEntry } from "./helper/operations-calculated-properties.js";
import { entryCashDetectedValidation } from "./helper/validation-detected-entry";
import AccountForm from './sub-components/AccountForm.vue';
import ls from '../../../settings/localStorageExtension';
import actions from "../../../permissions/actions-names.js"
import { bondType } from '@/helpers/enums';
export default {
components: { AccountForm },
data: () => ({
	alertNoBoxAccountDialog: false,
	entry: null,
	dialogDeleteCashEntry: false,
	actions,
	sum_difference_equivalent: { amount: null, currency_id: null, money_type: null},
	showAccountForm: false,
	show: false,
    bond_no: null,
    ...rules,
    addBondDialog: false,
    loading: false,
	items2: [],
	simplified_bond:{
	id: null,
	date: null,
	is_posted: null,
	bond_no: null,
	deleted_at: null,
	},
    bond_date: new Date().toISOString().substr(0, 10).toString(),
	messagesSelectRowValidation: [],
	linkedBoundRules: {
		debit: true,
		credit: true,
		currency_debit: true,
		currency_credit: true,
		currency_id: true,
    },

	updateBondLoading: false,
	revolvingBalance: null
}),

methods: {
	deleteEntry($event){
		this.entry = {...$event}
		this.dialogDeleteCashEntry = true
    },
    confirmDeleteEntry(){
		let bondId  = this.bond.id
        store.dispatch("bonds/deleteEntry", { bondId, bondType: bondType.cash, entryId: this.entry.id }).then( ()=>{
			this.fetchBondByNo(this.bond_no)
		}).finally(()=>{this.entry = null})
    },
    redirectToBond($event){
      console.log($event)
    },
    addBond(){
		this.loading = true
		store.dispatch("bonds/create",{ bondType: bondType.cash, date:this.bond_date})
		.then(() => { 
			this.bond_no = this.bond.bond_no 
			this.$router.push({ name: "cash-journal", params: { id: this.bond.id } })
			this.$refs.table.endLineInputValues = {date: new Date().toISOString()}
			this.$refs.table.onEsc()
			store.dispatch("configs/fetchAll")
		})
		.finally(() => (this.loading = false));
		this.addBondDialog = false
		this.bond_date = new Date().toISOString().substr(0, 10).toString()
    },
	/* eslint-disable */
	fetchBond(){
		var bond = this.simplified_bonds?.find(c=>c.bond_no == this.bond_no)
		if(bond && bond.id != Number(this.$route.params.id)){
			this.$router.push({name: 'cash-journal', params:{id: bond.id}})
				.then(()=>{
					this.$refs.table.openLoading();
					store.dispatch("bonds/fetch", {bondId: Number(this.$route.params.id), bondType: bondType.cash })
						.then(()=> { 
							store.dispatch("statements/fetchBoxBalance")
							this.$refs.table.endLineInputValues = {date: new Date().toISOString()},
							this.$refs.table.onEsc(),
							this.$refs.table.closeLoading();})
						})
					store.dispatch('statements/fetchBoxBalanceByNo', { bondNo: this.bond_no }).then((data) => {
						this.revolvingBalance = data.data
					})	
		}
    },
	fetchBondByNo(bondNo){
		if(bondNo){
		this.$refs.table.openLoading()
			store.dispatch("bonds/fetchBondByNumber", { bondType: bondType.cash, bondNo: bondNo })
				.then(()=> { 
					store.dispatch("statements/fetchBoxBalance")
					this.$refs.table.endLineInputValues = {date: new Date().toISOString()}, 
					this.$refs.table.onEsc()
					this.$refs.table.closeLoading()})
		}
    },
	/* eslint-disable */
    updateEntry(object){
		var entry  = refactorEntry(this.entries[object.rowIndex], this.configs.financial_file.default_currency_id)
		entry.bond_id = this.bond.id
		delete entry.currency_id
		entry.date = entry.date.slice(0, 10)
		
		this.$refs.table.$refs.table.$refs.table.valids[`valid_${object.rowIndex}`]
			?   store.dispatch("bonds/updateEntry", {
				bondId: this.bond.id,
				bondType: bondType.cash,
				entry
			})
			.then(() => { 
				object.deleteRowIndex()
			})
			.finally(()=>{
				this.$refs.table.loading = false;
				this.$nextTick(() => {
					this.$refs.table.$refs[`input_1`][0].$children[0].$refs.BeeNumericField.focus();
				})
			})
			: EventBus.$emit('error', this.$t('CashJournalPage.make-sure-the-data-entered-is-correct'))
		},
    addEntry(entry){
		console.log(entry.value);
		entry.value.bond_id = this.bond.id
		delete entry.value.currency_id
		entry.value.date = entry.value.date.slice(0, 10)
			store.dispatch("bonds/createEntry", {
			bondId: this.bond.id,
			bondType: bondType.cash,
			entry: entry.value
			})
			.then(() => {
				const dateInputValue =
					this.$refs.table.$refs[`input_${this.headers.findIndex(c => c.type === 'date')}`][0].value; 
					
                entry.deleteRowData({
					date: dateInputValue || new Date().toISOString(),
					note: entry.value.note
				})
			})
			.finally(()=>{
				this.$refs.table.loading = false;
				this.$nextTick(() => {
					this.$refs.table.$refs[`input_1`][0].$children[0].$refs.BeeNumericField.focus();
				})
			})
	},
	goToAccountStatement(entry){
		this.$router.push({ name: 'statement', params: { id: entry.account_id } })
	},
	posting(){
		this.updateBondLoading = true;
		store.dispatch("bonds/updateToPosted", { bondId:this.bond.id, bondType: bondType.cash }).then(()=>{
			Promise.all([store.dispatch("configs/fetchAll"),
				store.dispatch("bonds/fetch", {bondId: this.bond.id, bondType: bondType.cash }),
				store.dispatch("statements/fetchBoxBalance")
			]).finally(() => {
				this.updateBondLoading = false;
			});
		}).catch(() => {
			this.updateBondLoading = false;
		})
	},
	unPosting(){
		this.updateBondLoading = true;
		store.dispatch("bonds/updateToNonPosted", { bondId:this.bond.id, bondType: bondType.cash }).then( ()=>{
			Promise.all([store.dispatch("configs/fetchAll"),
				store.dispatch("bonds/fetch", {bondId: this.bond.id, bondType: bondType.cash }),
				store.dispatch("statements/fetchBoxBalance")
			]).finally(() => {
				this.updateBondLoading = false;
			});
		}).catch(() => {
			this.updateBondLoading = false;
		})
	},
	changeSumDifferenceEquivalent(toCurrencyId) {
		if(toCurrencyId)
		{
			if(this.sum_difference?.amount)
			{
				let amount = this.sum_difference.amount
				let fromCurrecyId = this.sum_difference.currency_id
				store.dispatch("currencies/exchangeToCurrency",{ toCurrencyId, amount, fromCurrecyId })
					.then(response => {
						_.set(this.sum_difference_equivalent,"amount", response.amount)
						_.set(this.sum_difference_equivalent,"currency_id", response.currency_id)
						_.set(this.sum_difference_equivalent,"money_type", this.sum_difference_equivalent_api?.money_type)
					})
			}
		}
	},
	statementAccount(){
		let box_id = this.configs?.accounts?.find(c=>c.is_box)?.id
		if(box_id)
			this.$router.push({ name: "statement", params: { id: box_id } }).catch(()=>{})
	},
	fetchEntry(entry){
		store.dispatch("bonds/fetchEntry",{ id: entry.id})
	},
    handlBlurBoundTable(entry) {
    	this.messagesSelectRowValidation = entryCashDetectedValidation(entry,this.linkedBoundRules);
    },
	async createAccount(){
		this.showAccountForm = true
		await store.dispatch("customStatements/fetchAll")
	},
	checkMainBox(){
		if(typeof this.main_box === 'string' && this.main_box.length === 0){
			this.alertNoBoxAccountDialog = true
		}
	},

},
mounted() {
	this.loading = false;
	window.observer.observe(document.querySelector("#tool-bar"))
	window.observer.observe(document.querySelector("#footer"))
	this.checkMainBox();
},
watch: {
	$route: function (to, from) {
		this.sum_difference_equivalent = { amount: null, currency_id: null, money_type: null}
		if(to.params.id != this.simplified_bonds?.find(c=>c.bond_no == this.bond_no)?.id || (from.name == "cash-journal" && to.name == 'cash-journals'))
		{	
			if(this.simplified_bonds.length > 0)
			{
				this.$refs.table.openLoading();
				store.dispatch("bonds/fetch", {bondId: this.simplified_bonds[this.simplified_bonds.length - 1].id, bondType: bondType.cash })
					.then(response=> { 
						store.dispatch("statements/fetchBoxBalance")
						this.bond_no = response.bond_no
						this.$refs.table.endLineInputValues = {date: new Date().toISOString()},
						this.$refs.table.onEsc(),
						this.$refs.table.closeLoading();})
			}
		}
	},

	main_box(){
		this.checkMainBox();
	}
},
  computed: {
	...mapState("configs" , ["configs"]),
	...mapState({ simplified_bonds: (state) => state.bonds.simplified_cash_bonds }),
	...mapState("statements" , ["box_balance"]),
	...mapState("accounts" , ["main_box"]),
	/*Avoid sharing bond store data when starting a new financial file, if it hasn't had cash bonds yet.*/
	...mapState({ cashBond: (state) => state.bonds.bond }),
	headers(){
		return [
			// {
			// 	text: this.$t('CashJournalPage.headers.sequence'),
			// 	value: 'order_inside_bond',
			// 	type: 'string',
			// 	width: '5%',
			// 	editable: false
			// },
			{
				text: '#',
				value: 'order_inside_bond',
				type: 'string',
				width: '2%',
				editable: false
			},
			// {
			// 	text: this.$t('CashJournalPage.headers.credit'),
			// 	value: 'credit',
			// 	type: 'money',
			// 	width: '8%',
			// 	editable: true, rules: [this.rules.money && this.linkedBoundRules.credit],
			// },
			{
				text: this.$t('CashJournalPage.headers.credit'),
				value: 'credit',
				type: 'money',
				width: '11%',
				editable: true, rules: [this.rules.money && this.linkedBoundRules.credit],
			},
			// {
			// 	text: this.$t('CashJournalPage.headers.debit'),
			// 	value: 'debit',
			// 	type: 'money',
			// 	width: '8%',
			// 	editable: true, rules: [this.rules.money && this.linkedBoundRules.debit],
			// },
			{
				text: this.$t('CashJournalPage.headers.debit'),
				value: 'debit',
				type: 'money',
				width: '11%',
				editable: true, rules: [this.rules.money && this.linkedBoundRules.debit],
			},
			// {
			// 	text: this.$t('CashJournalPage.headers.account'),
			// 	value: 'account_id',
			// 	type: 'accounts-autocomplete',
			// 	width: '16%',
			// 	editable: true, settings: { },  rules: [this.rules.required] 
			// },
			{
				text: this.$t('CashJournalPage.headers.account'),
				value: 'account_id',
				type: 'accounts-autocomplete',
				width: '14%',
				editable: true, settings: { },  rules: [this.rules.required] 
			},
			// {
			// 	text: this.$t('CashJournalPage.headers.note'),
			// 	value: 'note',
			// 	type: 'string',
			// 	width: '17%',
			// 	editable: true
			// },
			{
				text: this.$t('CashJournalPage.headers.note'),
				value: 'note',
				type: 'string',
				width: '17%',
				editable: true
			},
			// {
			// 	text: this.$t('CashJournalPage.headers.currency'),
			// 	value: 'currency_id',
			// 	type: 'currencies-autocomplete',
			// 	width: '9%',
			// 	editable: true, settings: { itemText: 'symbol' }, rules: [this.linkedBoundRules.currency_id],
			// },
			{
				text: this.$t('CashJournalPage.headers.currency'),
				value: 'currency_id',
				type: 'currencies-autocomplete',
				width: '5%',
				editable: true, settings: { itemText: 'symbol' }, rules: [this.linkedBoundRules.currency_id],
			},
			// {
			// 	text: this.$t('CashJournalPage.headers.currency-credit'),
			// 	value: 'currency_credit',
			// 	type: 'money',
			// 	width: this.$emerald.ifLang('es', '15%', '6%'),
			// 	editable: true, rules: [this.rules.money && this.linkedBoundRules.currency_credit],
			// },
			{
				text: this.$t('CashJournalPage.headers.currency-credit'),
				value: 'currency_credit',
				type: 'money',
				width: '11%',
				editable: true, rules: [this.rules.money && this.linkedBoundRules.currency_credit],
			},
			// {
			// 	text: this.$t('CashJournalPage.headers.currency-debit'),
			// 	value: 'currency_debit',
			// 	type: 'money',
			// 	width: this.$emerald.ifLang('es', '15%', '6%'),
			// 	editable: true, rules: [this.rules.money && this.linkedBoundRules.currency_debit],
			// },
			{
				text: this.$t('CashJournalPage.headers.currency-debit'),
				value: 'currency_debit',
				type: 'money',
				width: '11%',
				editable: true, rules: [this.rules.money && this.linkedBoundRules.currency_debit],
			},
			// {
			// 	text: this.$t('CashJournalPage.headers.price'),
			// 	value: 'currency_price',
			// 	type: 'numeric',
			// 	width: '8%',
			// 	editable: true, settings: { itemText: 'equivalentPrice' }, rules: [this.rules.money] 
			// },
			{
				text: this.$t('CashJournalPage.headers.price'),
				value: 'currency_price',
				type: 'numeric',
				width: '7%',
				editable: true, settings: { itemText: 'equivalentPrice' }, rules: [this.rules.money] 
			},
			{
				text: this.$t('CashJournalPage.headers.paper-document-no'),
				value: 'paper_document_no',
				type: 'string',
				width: '5%',
				editable: true
			},
			// {
			// 	text: this.$t('CashJournalPage.headers.date'),
			// 	value: 'date',
			// 	type: 'date',
			// 	width: '10%',
			// 	editable: true,
			// },
			{
				text: this.$t('CashJournalPage.headers.date'),
				value: 'date',
				type: 'date',
				width: '8%',
				editable: true,
			},
			{
				text: '',
				value: 'hint',
				type: 'hint',
				width: '2%',
				editable: false,
			},
		]
	},
	bond(){
		return this.bond_no ? this.cashBond : {}
	},
    entries: function(){
		return this.bond.entries || []
	},
	addable(){
		return this.bond.is_posted || !this.bond_no ? false : true
	},
	/** **/
	file_is_locked(){
        return this.configs?.financial_file?.is_locked },
	on_mdAndUp(){
		if(this.$vuetify.breakpoint.mdAndUp)
			return true
		return false;
	},
	sum_debits(){return this.bond?.statement_summary?.sum_result?.sum_debits || null},
	sum_credits(){return this.bond?.statement_summary?.sum_result?.sum_credits || null},
	sum_difference(){return this.bond?.statement_summary?.sum_result?.sum_difference || null},
	sum_difference_equivalent_api(){return this.bond?.statement_summary?.sum_result?.sum_difference_equivalent || null},
	on_lgAndUp(){
		if(this.$vuetify.breakpoint.lgAndUp)
			return true
		return false;
	},
	currency_debits(){return this.bond?.statement_summary?.sum_currencies_result?.currency_debits || null},
	currency_credits(){return this.bond?.statement_summary?.sum_currencies_result?.currency_credits || null},
	create_bonds_manually(){return ls.getAskBeforeBondCreation()},
	show_symbol_currencies(){return ls.getVisibleSymbolMoney()},
	bond_posting_ratio_tooltip(){return this.configs?.num_of_not_posted_bonds ? `${this.configs.num_of_not_posted_bonds} ${this.$t('CashJournalPage.not-posted-bonds')} ` : this.$t('CashJournalPage.all-bonds-are-posted') },
	bond_posting_ratio(){return this.configs?.num_of_total_bonds ?   100-(this.configs.num_of_not_posted_bonds*100)/this.configs.num_of_total_bonds : 100  },
	bond_posting_ratio_caption(){ return `${this.configs?.num_of_not_posted_bonds}/${this.configs?.num_of_total_bonds}`},
	custom_configs(){return {...this.configs, accounts : this.configs.accounts ? this.configs.accounts.filter(c=>c.type == 2 && !c.is_box) : [], currencies: this.configs.currencies? this.configs.currencies.filter(c=>c.id != this.configs.financial_file.default_currency_id): []}},
	actionsList(){
		return [
			{
				name: "account-statement",
				disabled: false,
				action_name: actions.GET,
				text: this.$t('CashJournalPage.context-menu.account-statement')
			},
			{
				name: "edit",
				disabled: this.bond.is_posted,
				action_name: actions.EDIT,
				text: this.$t('CashJournalPage.context-menu.edit')
			},
			{
				name: "delete-item",
				disabled: this.bond.is_posted,
				action_name: actions.DELETE,
				text: this.$t('CashJournalPage.context-menu.delete')
			}
		]
	} 
 },
async beforeRouteEnter(to, from, next) {
	let promises = []
		
	let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch("configs/fetchAll"))

	let bonds = JSON.parse(JSON.stringify(store.state.bonds.simplified_cash_bonds))
	if(bonds.length == 0)
		promises.push(store.dispatch("bonds/fetchAll", { bondType: bondType.cash }))
		
	await Promise.all(promises)

	if(to.params.id)
	{
		if(to.name != 'cash-journal')
		{
			store.dispatch("accounts/getMainBox").then(response => {
				if(!!response)
					store.dispatch("statements/fetchBoxBalance")
			})
				
			next({name: 'cash-journal', params:{id: to.params.id}})
		}	
	}	
	else
	{
		bonds = JSON.parse(JSON.stringify(store.state.bonds.simplified_cash_bonds))
		if(bonds.length > 0)
			next({ name: 'cash-journal', params:{id: bonds[bonds.length -1].id }})
		else
		{
			store.dispatch("accounts/getMainBox").then(response => {
				if(!!response)
					store.dispatch("statements/fetchBoxBalance")
			})
		}
			
	}
	next(
		vm => {
		if(to.name == "cash-journal")
		{
			if(to.params.id)
			{
				vm.$refs.table.openLoading();
				store.dispatch("bonds/fetch", {bondId: Number(to.params.id), bondType: bondType.cash })
					.then(response=> { 
						store.dispatch('statements/fetchBoxBalanceByNo', { bondNo: response.bond_no }).then((data) => {
							vm.revolvingBalance = data.data
						})	
							store.dispatch("accounts/getMainBox").then(response => {
							if(!!response)
							store.dispatch("statements/fetchBoxBalance") 
						})
						vm.bond_no = response.bond_no
						vm.$refs.table.endLineInputValues = {date: new Date().toISOString()},
						vm.$refs.table.onEsc(),
						vm.$refs.table.closeLoading();
					})
			}
					
        }})
}
};
</script>
<style scoped>
.medium-placeholder .v-label {
  	font-size: 0.7rem !important;
}
.my-border {
	border: 1px solid !important;
	border-color: #f1f1f1 !important;	
}
.colored-border {
  	border-right: #D39A38 !important;
}
</style>
<style>
.v-bottom-navigation {
	overflow-y: unset;
	box-shadow: 0px 10px 5px #eee, 0px -2px 5px gainsboro !important;
	background: linear-gradient(180deg, rgba(241,241,241,1) 0%, rgba(230,240,245,1) 100%);
}
</style>